import { render, staticRenderFns } from "./SupplierColorTextInput.vue?vue&type=template&id=f155b2ba"
import script from "./SupplierColorTextInput.ts?vue&type=script&lang=ts&external"
export * from "./SupplierColorTextInput.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports